'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import { WorkExperiencePage } from './-components/WorkExperiencePage';
import { isWorkExperienceTabMockEnabled } from './-shared/featureFlag';
export const Route = createFileRoute('/_staff/person/$id/_profile/work-experience/')({
  component: RouteComponent
});
function RouteComponent() {
  if (!isWorkExperienceTabMockEnabled()) return <NotFound />;
  return <WorkExperiencePage />;
}